var modules_3717c142 = {"container":"Link_module_container__9fcf146d","color-blue":"Link_module_colorBlue__9fcf146d","color-gray":"Link_module_colorGray__9fcf146d","color-black":"Link_module_colorBlack__9fcf146d","strong":"Link_module_strong__9fcf146d"};
import "../../../assets/esm/components/Typography/src/Link~DlOye6Xe.css";

export { modules_3717c142 as default };
//# sourceMappingURL=Link.module.less.js.map
